import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const testimonials = [{
  quote: 'Seguí el plan hora a hora y en el día 2 ya tenía mi primer pago de $35. Nunca pensé que fuera tan directo y simple.',
  initial: 'M',
  name: 'María G., Colombia',
  subtitle: 'Primera venta: 31 horas después'
}, {
  quote: 'Lo que más me sorprendió fueron los scripts. Copié y pegué el mensaje, lo mandé a 5 personas y 2 me respondieron ese día. Cerré $60 en servicios.',
  initial: 'C',
  name: 'Carlos R., México',
  subtitle: 'Resultado: $60 en el día 1'
}, {
  quote: 'Soy mamá, trabajo desde casa y no tenía tiempo para cursos largos. Este plan es diferente porque te dice exactamente qué hacer cada hora. En 48 horas generé $45.',
  initial: 'A',
  name: 'Ana L., Argentina',
  subtitle: 'Resultado: $45 en 48 horas'
}];
export const Testimonials = () => {
  return <section className="py-20 md:py-24 bg-[#0a0a0a]" data-id="element-192">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-193">
        <FadeIn data-id="element-194">
          <div className="text-center mb-14" data-id="element-195">
            <span className="text-[#ADFF2F] font-bold tracking-[0.2em] uppercase text-sm mb-4 block" data-id="element-196">
              Resultados reales de personas reales
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight" data-id="element-197">
              Ellos lo aplicaron. Esto fue lo que pasó:
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-198">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.15} data-id="element-199">
              <div className="bg-[#111111] border border-white/10 border-t-2 border-t-[#ADFF2F] rounded-xl p-6 md:p-7 h-full flex flex-col hover:border-t-[#ADFF2F] hover:shadow-[0_0_30px_rgba(173,255,47,0.1)] transition-shadow" data-id="element-200">
                {/* Stars */}
                <div className="flex gap-1 mb-4" data-id="element-201">
                  {[...Array(5)].map((_, idx) => <Star key={idx} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-202" />)}
                </div>

                {/* Quote */}
                <p className="text-white italic text-base md:text-lg leading-relaxed mb-6 font-sans flex-1" data-id="element-203">
                  "{t.quote}"
                </p>

                {/* Author */}
                <div className="flex items-center gap-3 pt-4 border-t border-white/5" data-id="element-204">
                  <div className="w-11 h-11 rounded-full bg-[#ADFF2F] flex items-center justify-center shrink-0" data-id="element-205">
                    <span className="text-black font-bold text-lg font-sans" data-id="element-206">
                      {t.initial}
                    </span>
                  </div>
                  <div data-id="element-207">
                    <p className="text-white font-semibold font-sans text-sm" data-id="element-208">
                      {t.name}
                    </p>
                    <p className="text-gray-500 text-xs font-sans" data-id="element-209">
                      {t.subtitle}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};